document.getElementById("add_to_baskets").addEventListener("click", function(event) {
  event.preventDefault();
  const productInputs = Array.from(document.querySelectorAll('.product-data-id')).reverse();
  const mountInputs = Array.from(document.querySelectorAll('.mount_value_properties')).reverse();
  
 // console.log(mountInputs);
 // debugger;
  // Build the items array
  const items = Array.from(productInputs).map((input, index) => ({
    id: input.value,
    quantity: 1,
    properties: {
      "Mount & Passepartout": mountInputs[index]?.value || ""
    }
  }));
  // Send all items in one request using /cart/add.js
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items })
  })
  .then(response => {
    if (!response.ok) throw new Error('Cart add failed');
    return response.json();
  })
  .then(data => {
    // All items added, now show updated cart
    $('cart-drawer').load(window.location.href + ' #CartDrawer');
    $('#cart-icon-bubble').load(location.href + " #cart-icon-bubble");
    setTimeout(() => {
      $('cart-drawer').removeClass('is-empty').addClass('active');
    }, 1000);
  })
  .catch(error => {
    console.error('Error adding items:', error);
  });
});

// variant change of the products using collection page 
// document.addEventListener("DOMContentLoaded", () => {
//   const productBlocks = document.querySelectorAll('.product-options-with-values');

//   productBlocks.forEach(block => {
//     const variantSelect = block.querySelector('select[name="id"]');
//     if (!variantSelect) {
//       console.warn('Missing variant select in product block');
//       return;
//     }

//     function updateVariantSelection() {
//       const material = block.querySelector('input[name^="material"]:checked')?.value;
//       const frame = block.querySelector('input[name^="choose a frame"]:checked')?.value;
//       const size = block.querySelector('input[name^="size"]:checked')?.value;

//       if (!material || !frame || !size) {
//         console.warn('One or more selected options missing');
//         return;
//       }

//       console.log(material, frame, size);

//       const variantValue = `${material} / ${frame} / ${size}`;
//       const image_alt = `framed-${material}-${frame}`.toLowerCase();

//       const matchingOption = Array.from(variantSelect.options).find(opt => opt.value === variantValue);
//       console.log(matchingOption);

//       let MainParent = block.closest('.collection-product-layout');
//       const productIndex = MainParent?.getAttribute('data-product-index');
      
//       // Always add "print" class by default
//       MainParent?.classList.add('print');
      
//       // Now check material
//       if (material.toLowerCase() === 'canvas') {
//         MainParent?.classList.add('canvas');
//         MainParent?.classList.remove('print');
//         MainParent?.querySelector('.collection-mount_value')?.style.setProperty('opacity', 0);
//         const mountInput = MainParent?.querySelector('input.mount_value');
//         const mountSelect = MainParent?.querySelector('.mount input[value="No"]');
//         if (mountSelect) {
//              mountSelect.click();
//           // mountSelect.selectedIndex = 0;
//           // mountSelect.dispatchEvent(new Event('change'));
//         }

        
//         //if (mountInput) mountInput.value = 'No';
//       } else {
//         MainParent?.classList.remove('canvas'); // remove canvas if not selected
//         MainParent?.querySelector('.collection-mount_value')?.style.setProperty('opacity', 1);
//       }


//       function showImageByAlt(altText, container, productIndex) {
//         const productContainer = document.querySelector(`.collection-product-layout[data-product-index="${productIndex}"]`);
//         const Sliderimages = productContainer?.querySelectorAll('.frame_images') || [];
//         const images = container.querySelectorAll('.frame_images');
//         images.forEach(img => {
//           if (img.alt === altText) {
//             img.classList.add('show');
//             img.classList.remove('hide');
//           } else {
//             img.classList.add('hide');
//             img.classList.remove('show');
//           }
//         });

//         Sliderimages.forEach(slideimg => {
//           if (slideimg.alt === altText) {
//             slideimg.classList.add('show');
//             slideimg.classList.remove('hide');
//           } else {
//             slideimg.classList.add('hide');
//             slideimg.classList.remove('show');
//           }
//         });
        
//       }

//       if (MainParent) {
//         showImageByAlt(image_alt, MainParent, productIndex);
//       }

//       if (matchingOption) {
//         let variant_id = matchingOption.getAttribute('data-id');
//         const variantIdInput = MainParent?.querySelector('input.product-data-id');
//         if (variantIdInput) variantIdInput.value = variant_id;
//         variantSelect.value = matchingOption.value;
//       } else {
//         variantSelect.selectedIndex = -1;
//       }
//     }

//     // Attach change events to all radio inputs in this block
//     const radios = block.querySelectorAll('input[type="radio"]');
//     radios.forEach(radio => {
//       radio.addEventListener("change", updateVariantSelection);
//     });

//     // Run once on load
//     updateVariantSelection();
//   });
// });
// document.addEventListener("DOMContentLoaded", () => {
//     const productBlocks = document.querySelectorAll('.product-options-with-values');

//     productBlocks.forEach(block => {
//     const materialSelect = block.querySelector('select[data-index="0"]:not([name="id"])');
//     const frameSelect = block.querySelector('select[data-index="1"]');
//     const sizeSelect = block.querySelector('select[data-index="2"]');
//     const variantSelect = block.querySelector('select[name="id"]');

//     if (!materialSelect || !frameSelect || !sizeSelect || !variantSelect) {
//       console.warn('One or more selects missing in a product block, skipping...');
//       return;
//     }

//     function updateVariantSelection() {
//       const material = materialSelect.value;
//       const frame = frameSelect.value;
//       const size = sizeSelect.value;
//       console.log(material, frame,size);

//       const variantValue = `${material} / ${frame} / ${size}`;
//       console.log('welcome', variantValue);
//       const image_alt = `framed-${material}-${frame}`.toLowerCase();
//       let MainParent = block.closest('.collection-product-layout');
//       const productIndex = MainParent?.getAttribute('data-product-index');
      
//       const matchingOption = Array.from(variantSelect.options).find(
//         option => option.value === variantValue
//       );
//       console.log(matchingOption);

//        function showImageByAlt(altText, container, productIndex) {
//         const productContainer = document.querySelector(`.collection-product-layout[data-product-index="${productIndex}"]`);
//         const Sliderimages = productContainer?.querySelectorAll('.frame_images') || [];
//         const images = container.querySelectorAll('.frame_images');
//         images.forEach(img => {
//           if (img.alt === altText) {
//             img.classList.add('show');
//             img.classList.remove('hide');
//           } else {
//             img.classList.add('hide');
//             img.classList.remove('show');
//           }
//         });
//        }
//          if (MainParent) {
//           showImageByAlt(image_alt, MainParent, productIndex);
//         }
//       if (matchingOption) {
//         let variant_id = matchingOption.getAttribute('data-id');
//         matchingOption.closest('.collection-product-layout').querySelector('input.product-data-id').value = variant_id;
//          const event = new Event('change', { bubbles: true });
//           variantSelect.dispatchEvent(event);
//           variantSelect.value = matchingOption.value;
//       } else {
//         variantSelect.selectedIndex = -1;
//       }
//     }

 
//     materialSelect.addEventListener("change", updateVariantSelection);
//     frameSelect.addEventListener("change", updateVariantSelection);
//     sizeSelect.addEventListener("change", updateVariantSelection);

//     updateVariantSelection();
//   });
// });

// document.addEventListener("DOMContentLoaded", () => {
//   const productBlocks = document.querySelectorAll('.collection-product-layout');

//   productBlocks.forEach(block => {
//     const mountInputs = block.querySelectorAll('.mount input[type="radio"]');

//     function updateMountSelection() {
//       const mountChecked = block.querySelector('.mount input[type="radio"]:checked');
//       if (!mountChecked) return;

//       const mountValue = mountChecked.value;
//       const mountHiddenInput = block.querySelector('input.mount_value_properties');
//       if (mountHiddenInput) mountHiddenInput.value = mountValue;


//         if( mountValue === 'Yes')
//         {
//           block.classList.add('passepartout');
//         }
//         else {
//           block.classList.remove('passepartout');
//         }


//       // if (mountValue !== 'Yes') return;


//       const material = block.querySelector('input[name^="material"]:checked')?.value || '';
//       const frame = block.querySelector('input[name^="choose a frame"]:checked')?.value || '';
//       const size = block.querySelector('input[name^="size"]:checked')?.value || '';
//       const variantSelect = block.querySelector('select[name="id"]');
//       const variantValue = `${material} / ${frame} / ${size}`;

//       if( mountValue === 'Yes')
//       {
//         var imageAlt = `framed-${material}-${frame}-passepartout`.toLowerCase();
//       }
//       else {
//         var imageAlt = `framed-${material}-${frame}`.toLowerCase();
//       }

//       //const imageAlt = `framed-${material}-${frame}-passepartout`.toLowerCase();
//       const matchingOption = Array.from(variantSelect?.options || []).find(opt => opt.value === variantValue);

//       function showImageByAlt(altText, container, productIndex) {
//         console.log(mountValue, 'inside function');
//         const productContainer = document.querySelector(`.collection-product-layout[data-product-index="${productIndex}"]`);

//           if( mountValue === 'Yes')
//           {
//             productContainer.classList.add('passepartout');
//           }
//           else {
//             productContainer.classList.remove('passepartout');
//           }


        
//         const Sliderimages = productContainer?.querySelectorAll('.frame_images') || [];        
//         const images = container.querySelectorAll('.frame_images');
//         images.forEach(img => {
//           if (img.alt === altText) {
//             img.classList.add('show');
//             img.classList.remove('hide');
//           } else {
//             img.classList.add('hide');
//             img.classList.remove('show');
//           }
//         });

//         Sliderimages.forEach(slideimg => {
//           if (slideimg.alt === altText) {
//             slideimg.classList.add('show');
//             slideimg.classList.remove('hide');
//           } else {
//             slideimg.classList.add('hide');
//             slideimg.classList.remove('show');
//           }
//         });
        
//       }

//       if (matchingOption) {
//         const parentBlock = matchingOption.closest('.collection-product-layout') || block;
//         const productIndex = parentBlock?.getAttribute('data-product-index');
//         showImageByAlt(imageAlt, parentBlock, productIndex);
//       }
//     }

//     // Attach to all mount radio buttons
//     mountInputs.forEach(input => {
//       input.addEventListener("change", updateMountSelection);
//     });

//     updateMountSelection(); // Initial run
//   });
// });

// document.addEventListener("DOMContentLoaded", function () {

//   //var formattedDiscount = ``;
  
//   const dropdowns = document.querySelectorAll(".custom-frame-dropdown");

//   dropdowns.forEach(dropdown => {
//     const selected = dropdown.querySelector(".selected-option");
//     const optionsList = dropdown.querySelector(".frame-options-list");
//     const options = dropdown.querySelectorAll("li");

//     selected.addEventListener("click", function (e) {
//       e.stopPropagation();
//       closeAllDropdownsExcept(dropdown);
//       dropdown.classList.toggle("open");
//     });

//     options.forEach(option => {
//       option.addEventListener("click", function () {
//         const value = option.getAttribute("data-value");
//         const ImageUrl = option.getAttribute("data-image-url");

//         // 🧼 Clear previous content
//         selected.innerHTML = '';

//         // 📝 Append the selected option text
//         const textNode = document.createTextNode(option.textContent);
//         selected.appendChild(textNode);

//         selected.setAttribute("data-value", value);

//         // 🖼 If ImageUrl is available, create and append the swatch span
//         if (typeof ImageUrl !== 'undefined' && ImageUrl !== null && ImageUrl !== '') {
//           const swatchSpan = document.createElement('span');
//           swatchSpan.className = 'swatch custom_print';
//           swatchSpan.style.setProperty('--swatch--background', `url(${ImageUrl})`);
//           swatchSpan.style.setProperty('--swatch-focal-point', '50.0% 50.0%'); // Default focal point
//           selected.appendChild(swatchSpan);
//         }

        
//         dropdown.classList.remove("open");

//         // 🟡 Fetch selected values from the same product block
//         const productContainer = dropdown.closest('.collection-product-layout');
//         let productsTotalPrices = parseFloat(document.querySelector('.bundle-product-price .products-price').getAttribute('data-total-price').replace(/,/g, ''));
//         let discountValue = parseFloat(document.querySelector('.bundle-product-price .discount_label').getAttribute('data-discount'));
//         if (!productContainer) return;

//         const productIndex = productContainer.getAttribute('data-product-index');
//         const selectedMaterial = productContainer.querySelector('.custom_material')?.getAttribute('data-value') || '';
//         const selectedFrame = productContainer.querySelector('.custom_choose_frame')?.getAttribute('data-value') || '';
//         const selectedSize = productContainer.querySelector('.custom_Size')?.getAttribute('data-value') || '';
//         const selectedMount = productContainer.querySelector('.custom_mount')?.getAttribute('data-value') || '';
//         const mountHiddenInput = productContainer.querySelector('input.mount_value_properties');

//         const variantSelect = productContainer.querySelector('select[name="id"]');
//         const variantValue = `${selectedMaterial} / ${selectedFrame} / ${selectedSize}`;
//         const productPrice = parseFloat(productContainer.querySelector('.product-price')?.getAttribute('data-product-price') || '');
//         const matchingOption = Array.from(variantSelect.options).find(opt => opt.value === variantValue);
        
//         let remaingPrice = productsTotalPrices - productPrice;
//         //console.log('matchingOption', matchingOption,productPrice, productsTotalPrices);
//         if (matchingOption) {
//           let variant_id = matchingOption.getAttribute('data-id');
//           let variantCurrency = matchingOption.getAttribute('data-currency');
//           let variantPrice = parseFloat(matchingOption.getAttribute('data-price'));
//           let variantCurrencyCode = matchingOption.getAttribute('data-last-currency');
//           let totalPrice = variantCurrency+'. '+variantPrice.toFixed(2)+' '+variantCurrencyCode;
//           productContainer.querySelector('.product-price').setAttribute("data-product-price", variantPrice);
//           let totalProductsPrice = remaingPrice + variantPrice;
//           //let totalProdutsPriceFormat = totalProductsPrice.toFixed(2);
//           //console.log(discountValue);
//           if(discountValue != '' || discountValue != NaN && discountValue != null) {
//             let discountPrice = totalProductsPrice - (totalProductsPrice * discountValue / 100);
//             //console.log('discountPrice'+discountPrice);
//               var formattedDiscount = discountPrice.toLocaleString('en-US', {
//               minimumFractionDigits: 2,
//               maximumFractionDigits: 2
//             });
//             //console.log('formattedDiscount',formattedDiscount);
//             document.querySelector('.bundle-product-price .remaining_price span').textContent = variantCurrency+'. '+formattedDiscount+' '+variantCurrencyCode;
//            // console.log(formattedDiscount, 'outside function');
//            // installmentPrice(formattedDiscount);

//           }
//           //console.log(discountprice, totalProductsPrice, (totalProductsPrice * discountValue / 100));
//           const formatted = totalProductsPrice.toLocaleString('en-US', {
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2
//           });
//           productContainer.querySelector('.product-price').textContent = totalPrice;
//           document.querySelector('.bundle-product-price .products-price span').textContent = variantCurrency+'. '+formatted+' '+variantCurrencyCode;
//           document.querySelector('.bundle-product-price .products-price').setAttribute("data-total-price", totalProductsPrice);
//           const variantIdInput = productContainer?.querySelector('input.product-data-id');
//           if (variantIdInput) variantIdInput.value = variant_id;
//           variantSelect.value = matchingOption.value;
//         }        
        
        
//         if (mountHiddenInput) mountHiddenInput.value = selectedMount;

//         if (selectedMount === "Yes") {
//           productContainer.classList.add('passepartout');
//         } else {
//           productContainer.classList.remove('passepartout');
//         }

//         // 📷 Build image alt key
//         let imageAlt = selectedMount === "Yes"
//           ? `framed-${selectedMaterial}-${selectedFrame}-passepartout`.toLowerCase()
//           : `framed-${selectedMaterial}-${selectedFrame}`.toLowerCase();

//         const productContainerSlide = document.querySelector(`.collection-product-layout[data-product-index="${productIndex}"]`);
//         const Sliderimages = productContainerSlide?.querySelectorAll('.frame_images') || [];        

//         Sliderimages.forEach(slideimg => {
//           if (slideimg.alt === imageAlt) {
//             slideimg.classList.add('show');
//             slideimg.classList.remove('hide');
//           } else {
//             slideimg.classList.add('hide');
//             slideimg.classList.remove('show');
//           }
//         });
        
//         // ✅ Show image by alt inside this container
//         const images = productContainer.querySelectorAll('.frame_images');
//         images.forEach(img => {
//           if (img.alt.toLowerCase() === imageAlt) {
//             img.classList.add('show');
//             img.classList.remove('hide');
//           } else {
//             img.classList.add('hide');
//             img.classList.remove('show');
//           }
//         });

//         // 📦 (Optional) Update hidden input or variant ID here if needed
//       });
//     });
//   });

//   document.addEventListener("click", function () {
//     closeAllDropdownsExcept();
//   });

//   function closeAllDropdownsExcept(current = null) {
//     document.querySelectorAll(".custom-frame-dropdown").forEach(d => {
//       if (d !== current) d.classList.remove("open");
//     });
//   }

//     // Shopify Liquid product object
//     const productData = null;
//     const currency = '';
//     const lang = '';
//     const publicKey = 'pk_0197ca39-7584-0dc2-c380-d6ffbc826fa5'; // Replace with your real Tabby public key

//     console.log(formattedDiscount);
//     function getSelectedVariantPrice() {
//       return ;
//     }
  
//     function refreshTabby() {
//       const price = getSelectedVariantPrice();
//       console.log(price);
//       if (!price) return;

//       const promo = document.getElementById('TabbyPromo');
//       if (promo) promo.innerHTML = '';

//       const merchantCode = (currency === 'AED') ? 'default' :
//                            (currency === 'SAR') ? 'ksa' :
//                            (currency === 'KWD') ? 'KW' : undefined;

//       const config = {
//         selector: '#TabbyPromo',
//         currency,
//         price,
//         lang,
//         publicKey
//       };
//       if (merchantCode) config.merchantCode = merchantCode;

//       new TabbyPromo(config);
//     }

//     const script = document.createElement('script');
//     script.src = 'https://checkout.tabby.ai/tabby-promo.js';
//     script.async = true;
//     script.onload = () => {
//       refreshTabby();

//       // Listen for variant selector changes
//       // const variantSelector = document.querySelector('form[action*="/cart/add"] select');
//       // if (variantSelector) {
//       //   variantSelector.addEventListener('change', refreshTabby);
//       // }

//       // // Observe direct variant input changes
//       // const variantInput = document.querySelector('input[name="id"]');
//       // if (variantInput) {
//       //   const observer = new MutationObserver(() => {
//       //     refreshTabby();
//       //   });
//       //   observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
//       // }
      
//     };
//     document.body.appendChild(script);

  
// });


const updateMinHeight = () => {
  const div = document.getElementById('tabby_installments_div');
  if (div) {
    div.style.minHeight = `${div.offsetHeight}px`;
  }
};

window.addEventListener('resize', updateMinHeight);
window.addEventListener('load', updateMinHeight);
